<script>
import { required } from "vuelidate/lib/validators";
import moment from "moment";
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import formcombobox from "@/router/views/FormComponet/formcombobox.vue";
import BirimSecimi from "../../FormComponet/BirimSecimiAnaBirim.vue";

export default {
  mixins: [Api, Sabit],
  page: {
    title: "Soru Formu Raporları",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    PageHeader,
    formcombobox,
    BirimSecimi
  },
  data() {
    return {
      title: this.$t("StrIcDegerGirisRapor.Title"),
      items: [
        {
          text: this.$t("StrIcDegerGirisRapor.Page.Anasayfa"),
          href: "/",
        },
        {
          text: this.$t("StrIcDegerGirisRapor.Page.UstMenu"),
          active: true,
        },
        {
          text: this.$t("StrIcDegerGirisRapor.Title"),
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      TableData: {},
      TableDonemData: {},
      AllTableData: {},
      TableKanitData: [],
      TableKanit: [],
      DonemCombobox: [],
      BirimIdCombobox: [],
      AnaBaslikCombobox: [],
      BirimAdi: "",
      Degerlendirmeturleri:[
            {"Id":"1","Value":"Kalite Öz Değerlendirme"},
            {"Id":"2","Value":"Akran Değerlendirme"},
            {"Id":"3","Value":"Program Öz Değerlendirme"},
            {"id":"4","value":"İç Değerlendirme"}
  
          ],
      DegerlendirmeturleriCombobox: [],
      Filter: {
        Donem: "",
        BirimId: "",
        AnaBaslik: "",
        AltBaslik: "",
        RaporTipi: "",
        Degerlendirmetur: 1
      },
      KurumAdi: this.$config.KURUM_ADI,
      Year: moment(new Date()).format("YYYY")
    };
  },

  validations: {
    Filter: {
      Donem: { required },
      BirimId: {},
      AnaBaslik: {},
      AltBaslik: {},
      RaporTipi: { required },
      Degerlendirmetur: { required }
    },
  },
  methods: {
    Get() { },
    FilterGet() {
      if (this.Filter.AnaBaslik != 1) {
        this.$v.$touch();
        if (!this.$v.$invalid) {
          this.DonemAdi = this.DonemCombobox.filter((notification) =>
            notification.Id.includes(this.Filter.Donem)
          )[0].Value;
          let Filter =
            "&DonemId=" +
            this.Filter.Donem +
            "&BirimId=" + this.Filter.BirimId +
            "&DetayId=" +
            this.Filter.AnaBaslik +
            "&Degerlendirmetur=" + this.Filter.Degerlendirmetur;
          this.ActionsFilterGet({
            Service: "StrIcDegerGiris/GetVeriGirisFormu",
            Page: this.Page,
            Filter: Filter,
          }).then((res) => {
            this.AllTableData = [];
            if (res.Data[0]) {
              this.AllTableData = res.Data;
              this.Page.PageDataSize = res.TotalCount;
              this.ActionsSingleGet({
                Service: "obirim",
                Id: this.Filter.BirimId,
              }).then((res) => {
                this.BirimAdi = res.Data.BirimAdi;
                this.TableKanitData = [];
                for (var TableData in this.AllTableData) {
                  for (var Data in this.AllTableData[TableData].Tablolar) {
                    if (this.AllTableData[TableData].Tablolar[Data].Tablolar.length > 0) {
                      for (var SubData in this.AllTableData[TableData].Tablolar[Data].Tablolar) {
                        this.ActionsFilterGet({
                          Service: "StrKontrolGirisKanit",
                          Page: this.Page,
                          Filter: "&IcDegerId=" + this.AllTableData[TableData].Tablolar[Data].Tablolar[SubData].Giris.Id,
                        }).then((res) => {
                          this.TableKanitData.push(res.Data);


                        });
                      }
                    }

                  }

                }


              });


            }
          });
        }
      } else {
        this.FilterAllTittle();
      }
    },
    FilterAllTittle() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.DonemAdi = this.DonemCombobox.filter((notification) =>
          notification.Id.includes(this.Filter.Donem)
        )[0].Value;
        this.ActionsFilterGet({
          Service: "StrIcDegerGiris/GetVeriGirisFormu",
          Page: this.Page,
          Filter: "&DonemId=" + this.Filter.Donem + "&BirimId=" + this.Filter.BirimId +  "&Degerlendirmetur=" + this.Filter.Degerlendirmetur
        }).then((res) => {
          this.TableData = [];
          if (res.Data) 
          {
            this.AllTableData = res.Data;
            this.Page.PageDataSize = res.TotalCount;
            this.ActionsSingleGet({
              Service: "obirim",
              Id: this.Filter.BirimId,
            }).then((res) => {
              this.BirimAdi = res.Data.BirimAdi;
                this.TableKanitData = [];
                for (var TableData in this.AllTableData) {
                  for (var Data in this.AllTableData[TableData].Tablolar) {
                      for (var SubData in this.AllTableData[TableData].Tablolar[Data].Tablolar) {
                        this.ActionsFilterGet({
                          Service: "StrKontrolGirisKanit",
                          Page: this.Page,
                          Filter: "&IcDegerId=" + this.AllTableData[TableData].Tablolar[Data].Tablolar[SubData].Giris.Id,
                        }).then((res) => {
                          if(res.Data.length > 0){
                            this.TableKanitData.push(res.Data);
                          }

                        });
 
                    }

                  }

                }



            });


          }
        });
      }
    },
    StrIcDegerGirisGet() {
      this.StrIcDegerGirisData = [];
      let Filter =
        "&Donemid=" + this.Filter.Donem + "&Birimid=" + this.Filter.BirimId;
      this.ActionsFilterGet({
        Service: "StrIcDegerGiris",
        Page: this.Page,
        Filter: Filter,
      }).then((res) => {
        this.StrIcDegerGirisData = res.Data;
      });
    },
    FilterBirimBazliGet() {

      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.DonemAdi = this.DonemCombobox.filter((notification) =>
          notification.Id.includes(this.Filter.Donem)
        )[0].Value;
        let Filter =
          "&DonemId=" +
          this.Filter.Donem + "&AnabaslikId=" + this.Filter.AnaBaslik
        this.ActionsFilterGet({
          Service: "StrRaporlama/GetIcDeger",
          Page: this.Page,
          Filter: Filter,
        }).then((res) => {
          this.TableDonemData = res.Data;


        });
      }
    },
    DegerlendirmeTureGoreBaslik(){
      this.AnaBaslikCombobox = [];
      this.ActionsFilterGet({ Service: "StrIcDegerTablo", Page: this.Page, Filter: "&Seviye=0&Degerlendirmetur=" + this.Filter.Degerlendirmetur }).then((res) => {
      for (var i = 0; i < res.Data.length; i++) {
        if (res.Data[i].Ustid == null) {
          this.AnaBaslikCombobox.push({
            Id: res.Data[i].Id,
            Value: res.Data[i].Tabloadi,
          });
        }
      }
      if(this.Filter.Degerlendirmetur==1){
        this.AnaBaslikCombobox.push({
        Id: "1",
        Value: "Tüm Başlıklar",
      });
      }

    });
    },


  },
  created() {
    let Page = {
      PageNumber: "1",
      PageSize: "9999",
    };
    this.ActionsFilterGet({ Service: "OKeyValues", Page: Page, Filter: "&Tip=1561&Kod=7" }).then(resp => {
      this.ActionsFilterGet({
        Service: "StrPerfDonem",
        Page: Page,
        Filter: "&Approval=true&UstIdDoluMu=true&TipId=" + resp.Data[0].Id,
      }).then((res) => {
        for (var i = 0; i < res.Data.length; i++) {
       {
            this.DonemCombobox.push({
              Id: res.Data[i].Id,
              Value: res.Data[i].Aciklama,
            });
          }
        }
      });
    });
    this.ActionsGet({ Service: "OBirim", Page: Page }).then((res) => {
      for (var i = 0; i < res.Data.length; i++) {
        this.BirimIdCombobox.push({
          Id: res.Data[i].Id,
          Value: res.Data[i].BirimAdi,
        });
      }
    });

    this.DegerlendirmeTureGoreBaslik();
  },
};
</script>

<template>
  <Loader>
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-sm-4">
                  <formcombobox :FormDataType="{
                    FieldName: 'Degerlendirmetur',
                    Field: 'combobox',
                    FieldTitle: $t('StrIcDegerGiris.Filtreleme.Degerlendirmetur'),
                    ComboDataArray: Degerlendirmeturleri,
                  }" :Value="Filter.Degerlendirmetur" :v="$v.Filter.Degerlendirmetur" @input="(Filter.Degerlendirmetur = $event),DegerlendirmeTureGoreBaslik()" />
                </div>
                <div class="col-sm-4">
                   <BirimSecimi
                        :title="$t(
                        'StrIcDegerGiris.Filtreleme.BirimId'
                      )"
                        :title_class="'mb-2'"
                        :closeOnSelect="true"
                        :sutun="'0'"
                        :multiple="false"
                        :YetkiKontrol="0"
                        :BirimTipId="null"
                        :v="$v.Filter.BirimId"
                        @Secilmis_Idler="Filter.BirimId=$event"
                      />
                </div>
                <div class="col-sm-4">
                  <formcombobox :FormDataType="{
                    FieldName: 'Donem',
                    Field: 'combobox',
                    FieldTitle: $t('StrIcDegerGiris.Filtreleme.Donem'),
                    ComboDataArray: DonemCombobox,
                  }" :Value="Filter.Donem" :v="$v.Filter.Donem" @input="Filter.Donem = $event" />
                </div>

                <div class="col-sm-4">
                  <formcombobox :FormDataType="{
                    FieldName: 'AnaBaslik',
                    Field: 'combobox',
                    FieldTitle: $t('StrIcDegerGiris.Filtreleme.AnaBaslik'),
                    ComboDataArray: AnaBaslikCombobox,
                  }" :Value="Filter.AnaBaslik" :v="$v.Filter.AnaBaslik" @input="Filter.AnaBaslik = $event" />
                </div>
                <div class="col-sm-4">
                  <formcombobox :FormDataType="{
                    FieldName: 'RaporTipi',
                    Field: 'combobox',
                    FieldTitle: $t('StrIcDegerGiris.Filtreleme.RaporTipi'),
                    ComboDataArray: [
                      { Id: 1, Value: 'Değerlendirme Raporu' },
                      //        { Id: 2, Value: 'Akran Raporu' },
                      { Id: 3, Value: 'Birim Bazlı İç Değerlendirme Raporu' }
                    ],
                  }" :Value="Filter.RaporTipi" :v="$v.Filter.RaporTipi" @input="Filter.RaporTipi = $event" />
                </div>
                <div class="col-sm-2">
                  <b-button @click="FilterGet()" v-if="Filter.RaporTipi != 3" class="btn btn-primary mt-4"
                    variant="primary">{{
                      $t("StrIcDegerGiris.Filtreleme.Button")
                    }}</b-button>
                  <b-button v-if="Filter.RaporTipi == 3" @click="FilterBirimBazliGet()" class="btn btn-primary mt-4"
                    variant="primary">{{
                      $t("StrIcDegerGiris.Filtreleme.Button")
                    }}</b-button>
                </div>
                <div class="col-sm-2 mt-3">
                  <b-dropdown variant="success" class="btn btn-rounded mb-2 me-2">
                    <template v-slot:button-content>
                      <i class="mdi mdi-file-export-outline me-1"></i>
                      {{ $t("StrBirimButceHarcamalari.Page.Yazdir") }}
                      <i class="mdi mdi-chevron-down"></i>
                    </template>
                    <b-dropdown-item href="javascript: void(0);" @click="ExcelExport('Harcama Giriş', 'İç Değer Giriş')">
                      {{
                        $t("StrBirimButceHarcamalari.Page.ExceleAktar")
                      }}</b-dropdown-item>
                    <b-dropdown-item href="javascript: void(0);" @click="Export2Word('exportContent', 'İç Değer Giriş')">
                      {{
                        $t("StrBirimButceHarcamalari.Page.WordeAktar")
                      }}</b-dropdown-item>
                  </b-dropdown>
                </div>
              </div>
              <div id="exportContent">
                <div class="table-responsive" ref="ExcelExportTable" v-if="Filter.RaporTipi == 1 && BirimAdi != ''">
                  <table class="table table-borderless mb-0" style="width: 100%; text-align: center;">
                    <thead>
                      <tr class="text-sm-center" style="height: 100px;">
                      </tr>
                      <tr class="text-sm-center" style="height: 200px;">
                        
                      </tr>
                      <tr style=" font-size: large;">
                        {{ KurumAdi }}
                      </tr>
                      <tr style=" font-size: medium;">
                        {{ this.BirimAdi }}
                      </tr>
                      <tr style=" font-size: medium; height:350px;">
                        KURUM İÇ DEĞERLENDİRME RAPORU
                      </tr>
                      <tr style="height: 100px; font-size: small;">
               
                      </tr>
                      <tr style="height: 100px; font-size: small;">
                        {{ Year }}
                      </tr>
                    </thead>
                  </table>
                  <table class="table table-borderless mb-0" style="border-collapse: collapse; width: 100%">
                    <tbody v-for="(TableData, number) in AllTableData" :key="number">
                      <tr>
                        <td style="border: 1px solid">
                          <b> {{ TableData.TabloAdi }}</b>
                        </td>
                      </tr>
                      <tr>
                        <td style="border: 1px solid">
                          <ul>
                            <template v-for="(TableVerileri, index) in TableData.Tablolar">
                              <li v-if="TableVerileri.Tablolar.length != 0" :key="index">
                                {{ TableVerileri.TabloAdi }}
                                <ul>
                                  <template v-for="(Tablolar, index) in TableVerileri.Tablolar">
                                    <ul :key="index">
                                      <li>
                                        <span>{{ Tablolar.TabloAdi }} </span>

                                      </li>
                                    </ul>
                                  </template>
                                </ul>
                              </li>
                            </template>
                          </ul>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div v-for="(TableData, number) in AllTableData" :key="number">
                    <table style="width: 100%">
                      <tbody>
                        <tr style="height: 50px;"></tr>
                        <tr>
                          <td>
                            <h5>{{ TableData.TabloAdi }}</h5>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div v-for="(TableVerileri, index) in TableData.Tablolar" :key="index">
                      <table style="width: 100%; margin-left: 25px;">
                        <thead>
                          <tr>
                            <td>
                              <h5>{{ TableVerileri.TabloAdi }}</h5>
                            </td>
                          </tr>
                        </thead>
                        <tbody v-for="(Tablolar, Index) in TableVerileri.Tablolar" :key="Index">
                          <tr>
                            <td>
                              <h5 style="margin-left: 25px;">{{ Tablolar.TabloAdi }}
                              </h5>
                            </td>
                          </tr>
                          <tr>
                            <p style="margin-left: 25px; font-weight: 300; font-size: 14px;"><span
                                v-html="Tablolar.Giris.Deger"></span></p>
                          </tr>
                          <tr>
                            <p style="margin-left: 25px; font-weight: 400; font-size: 14px;"><span
                                style="font-weight: 600; font-size: 14px;">Olgunluk Değeri:</span> {{
                                  Tablolar.Giris.Olgunluk
                                }}</p>
                          </tr>
                        </tbody>
                      </table>
                      <table v-if="TableKanitData.length > 0" style="margin-top: 25px; margin-left: 50px;">
                        <tbody>
                          <tr style="font-weight: 600; font-size: 16px;">
                            Kanıtlar
                          </tr>
                        </tbody>
                      </table>
                      <table v-for="(Tablolar, Index) in TableVerileri.Tablolar" :key="Index" >
                        <thead v-if="TableKanitData.length > 0">
                          <tr>
                            <h7 style="margin-left: 50px; font-weight: bold;">{{
                              Tablolar.TabloAdi
                            }}</h7>
                          </tr>
                        </thead>
                        <tbody v-for="(Kanit, Index) in TableKanitData" :key="Index">
                          <tr v-for="(SubKanit, index) in Kanit" :key="index">
                            <p style="margin-left: 50px;"
                              v-if="Tablolar.Giris.Id == SubKanit.IcDegerId">
                              <a target="_blank" :href="$config.FILES_URL + SubKanit.Fileurl">{{ SubKanit.Filename }}</a>

                            </p>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div id="exportContent">
                <div class="table-responsive" ref="ExcelExportTable"
                  v-if="Filter.RaporTipi == 3 && TableDonemData.Basliklar">
                  <table class="table table-borderless mb-0" style="border-collapse: collapse; width: 100%">
                    <thead>
                      <tr class="row">
                        <th class="text-sm-center" colspan="2" style="background-color: #2A3042; color:aliceblue">
                          BİRİM BAZLI İÇ KONTROL DEĞERLENDİRME RAPORU
                        </th>
                      </tr>
                    </thead>
                  </table>
                  <div v-for="TableDataVerileri in TableDonemData.Basliklar" :key="TableDataVerileri.Id">
                    <div v-for="TableData in TableDataVerileri.Basliklar" :key="TableData.Id">
                      <table class="table table-borderless mb-0" style="border-collapse: collapse; width: 100%"
                        v-if="TableData.Basliklar[0]">
                        <thead>
                          <tr class="row">
                            <th class="text-sm-center col-md-6" style="background-color: #2A3042; color:aliceblue"
                              colspan="1">
                            </th>
                            <th class="text-sm-center col-md-6" style="background-color: #2A3042; color:aliceblue"
                              colspan="1">
                              {{ TableDataVerileri.Tabloadi }}
                            </th>
                          </tr>
                          <tr class="row">
                            <th style="background-color: #2A3042; color: white" class="text-sm-center col-md-6">

                            </th>
                            <th style=" background-color: #2A3042; color: white" class="text-sm-center col-md-6">
                              {{ TableData.Tabloadi }}
                            </th>
                          </tr>

                        </thead>
                        <tbody v-for="Data in TableData.Basliklar" :key="Data.Id">
                          <tr class="row" style="background-color: #2A3042; color:aliceblue;">
                            <th class="text-sm-center col-md-6" style="border: 1px solid white;">
                              Birimler
                            </th>
                            <th class="text-sm-center col-md-6" style="border: 1px solid white;">
                              {{ Data.Tabloadi }}
                            </th>
                          </tr>
                          <tr class="row" v-for="SubData in Data.Girisler" :key="SubData.Id">
                            <td class="col-md-6">
                              {{ SubData.Birimadi }}
                            </td>
                            <th class="text-sm-center col-md-6">
                              <span v-html="SubData.Deger"></span>
                            </th>
                          </tr>
                          <tr colspan="2">

                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  </Loader>
</template>
